import { Component, model } from '@angular/core';

/**
 * O campo **honeypot** das aberturas públicas (change anti-abuso-superficie-publica): um input que
 * a pessoa não vê nem alcança, e que o robô que lê o HTML preenche. Preenchido, a API recusa o
 * envio com o mesmo 422 do desafio de formulário.
 *
 * Invisível **sem** `display:none`/`visibility:hidden` — alguns robôs pulam o que está escondido
 * assim: fica fora da tela por posição, fora do Tab (`tabindex="-1"`), fora do leitor de tela
 * (`aria-hidden`) e fora do autocompletar (`autocomplete="off"`, nome sem semântica de endereço).
 *
 * O valor sai pelo `model()` `valor`, e quem monta o `FormData` só o anexa quando não está vazio.
 */
@Component({
  selector: 'app-campo-honeypot',
  template: `
    <input
      type="text"
      name="desSite"
      autocomplete="off"
      tabindex="-1"
      aria-hidden="true"
      [value]="valor()"
      (input)="valor.set($any($event.target).value)"
    />
  `,
  styles: `
    :host {
      position: absolute;
      left: -10000px;
      top: auto;
      width: 1px;
      height: 1px;
      overflow: hidden;
    }
  `,
  host: { 'aria-hidden': 'true' },
})
export class CampoHoneypotComponent {
  readonly valor = model('');
}
